import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Logo IQ"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-logo-iq',
    templateUrl: './icon-logo-iq.component.html',
    styleUrls: ['./icon-logo-iq.component.scss'],
    standalone: false
})
export class IconLogoIQComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
